import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import Sparkline from "./Sparkline";

const TONE_COLORS = { blue: "#1a73e8", green: "#34A853", red: "#EA4335", amber: "#f29900", purple: "#9334e6" };

export default function StatCard({ icon: Icon, label, value, sublabel, tone = "blue", trend, sparkline }) {
  const tones = {
    blue: "bg-blue-50 dark:bg-blue-950/40 text-[#1a73e8]",
    green: "bg-green-50 dark:bg-green-950/40 text-[#34A853]",
    red: "bg-red-50 dark:bg-red-950/40 text-[#EA4335]",
    amber: "bg-amber-50 dark:bg-amber-950/40 text-[#f29900]",
    purple: "bg-purple-50 dark:bg-purple-950/40 text-[#9334e6]"
  };

  // trend: { direction: "up" | "down" | "flat", label: "12% vs last week" }
  const trendPositive = trend?.direction === "up";
  const trendNegative = trend?.direction === "down";

  return (
    <div className="google-card p-4 sm:p-5 bg-white dark:bg-[#303134] border border-[#dadce0] dark:border-[#3c4043] flex items-center gap-4">
      {Icon && (
        <div className={`p-3 rounded-2xl shrink-0 ${tones[tone] || tones.blue}`}>
          <Icon className="w-5 h-5 sm:w-6 sm:h-6" />
        </div>
      )}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <div className="text-xl sm:text-2xl font-bold text-[#202124] dark:text-[#e8eaed] truncate">{value}</div>
          {trend && (
            <span
              className={`inline-flex items-center gap-0.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full shrink-0 ${
                trendPositive
                  ? "bg-green-50 text-green-700 dark:bg-green-950/40 dark:text-green-300"
                  : trendNegative
                  ? "bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-300"
                  : "bg-[#f1f3f4] dark:bg-[#202124] text-[#9aa0a6]"
              }`}
            >
              {trendPositive && <ArrowUpRight className="w-3 h-3" />}
              {trendNegative && <ArrowDownRight className="w-3 h-3" />}
              {trend.label}
            </span>
          )}
        </div>
        <span className="text-xs text-[#5f6368] dark:text-[#9aa0a6] font-medium block truncate">{label}</span>
        {sublabel && <span className="text-[11px] text-[#70757a] dark:text-[#80868b] block truncate">{sublabel}</span>}
      </div>
      {sparkline && sparkline.length > 1 && <Sparkline data={sparkline} color={TONE_COLORS[tone] || TONE_COLORS.blue} />}
    </div>
  );
}
